import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
   title:{
      fontWeight: 700,
      fontSize: '1.8em',
      lineHeight: '15px',
      color: '#666666',
      marginTop: '-40px',
      marginBottom: '10px'
  },
  footer:{
     marginTop: '25px',
     display: 'flex',
     flexDirection: 'row',
     alignItems: 'center',
     justifyContent: 'space-between'
  },
  note:{
    color: '#666666',
    fontWeight: 700
  },
  textIcon: {
    fontSize: '1.3em',
    color: '#658D1B'
  },
  colorRed:{
    color: '#D63C43'
  }
}));

export default useStyles;
